export const SHOW_TOOLTIP = 'showTooltip';
export const HIDE_TOOLTIP = 'hideTooltip';
export const CENTER_CHANGE = 'centerChange';
export const ZOOM_CHANGE = 'zoomChange';
export const INIT = 'init';
